import React, { useState } from 'react';
import './UserNameScreen.css';

const UserNameScreen = ({ onUsernameSet, currentUsername }) => {
  const [username, setUsername] = useState(currentUsername || '');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate username
    if (!username.trim()) {
      setError('Please enter a username');
      return;
    }
    
    if (username.trim().length < 2) {
      setError('Username must be at least 2 characters long');
      return;
    }
    
    if (username.trim().length > 20) {
      setError('Username must be 20 characters or less');
      return;
    }
    
    // Check for valid characters (letters, numbers, spaces, dashes, underscores)
    const validPattern = /^[a-zA-Z0-9\s\-_]+$/;
    if (!validPattern.test(username.trim())) {
      setError('Username can only contain letters, numbers, spaces, dashes, and underscores');
      return;
    }
    
    setError('');
    onUsernameSet(username.trim());
  };

  const handleInputChange = (e) => {
    setUsername(e.target.value);
    if (error) setError(''); // Clear error when user starts typing
  };

  return (
    <div className="username-screen">
      <div className="username-container">
        <div className="username-header">
          <h1>Welcome to Connect 4!</h1>
          <div className="title-decoration">
            <div className="piece red"></div>
            <div className="piece yellow"></div>
            <div className="piece red"></div>
            <div className="piece yellow"></div>
          </div>
          <p className="welcome-text">
            Challenge Friends, Play with friends and Connect with friends
          </p>
        </div>

        <div className="username-form-container">
          <form onSubmit={handleSubmit} className="username-form">
            <div className="input-group">
              <label htmlFor="username" className="username-label">
                Your Username
              </label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={handleInputChange}
                placeholder="Enter your username"
                className={`username-input ${error ? 'error' : ''}`}
                maxLength="20"
                autoFocus
              />
              {error && <div className="error-message">{error}</div>}
              <div className="input-hint">
                More than 4 characters - can be combination of letters, symbols, and numbers
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="submit-btn">
                Start Playing
              </button>
            </div>
          </form>
        </div>

        {/* Floating pieces animation */}
        <div className="floating-pieces">
          <div className="floating-piece red piece-1"></div>
          <div className="floating-piece yellow piece-2"></div>
          <div className="floating-piece red piece-3"></div>
          <div className="floating-piece yellow piece-4"></div>
          <div className="floating-piece red piece-5"></div>
          <div className="floating-piece yellow piece-6"></div>
        </div>
      </div>
    </div>
  );
};

export default UserNameScreen;
